import React, { useState, useEffect } from 'react';
import { ref, onValue } from 'firebase/database';
import { database } from '../firebase';
import './Testimonials.css';

const Testimonials = () => {
  const [testimonials, setTestimonials] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const testimonialsRef = ref(database, 'testimonials');
    const unsubscribe = onValue(testimonialsRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const testimonialsList = Object.keys(data).map(key => ({
          id: key,
          ...data[key]
        }));
        setTestimonials(testimonialsList);
      } else {
        setTestimonials([]);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    if (testimonials.length === 0) return;

    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % testimonials.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [testimonials.length]);

  return (
    <section id="testimonials" className="testimonials">
      <div className="testimonials-bg" aria-hidden="true" />
      <div className="container">
        <div className="testimonials-header">
          <span className="testimonials-badge">Referanslar</span>
          <h2 className="testimonials-title">Müşteri Yorumları</h2>
          <p className="testimonials-subtitle">
            Binlerce müşterimizin memnuniyeti bizi her gün daha iyiye taşıyor.
          </p>
        </div>
        {loading || testimonials.length === 0 ? (
          <div className="testimonials-empty">
            <p>Henüz müşteri yorumu eklenmemiş.</p>
          </div>
        ) : (
          <>
            <div className="testimonials-slider">
              <div className="testimonials-track" style={{ transform: `translateX(-${currentIndex * 100}%)` }}>
                {testimonials.map((testimonial) => {
                  const rating = testimonial.rating || 5;
                  return (
                    <div key={testimonial.id} className="testimonial-item">
                      <div className="testimonial-card">
                        <span className="testimonial-quote" aria-hidden="true">"</span>
                        <div className="testimonial-stars">
                          {Array.from({ length: 5 }, (_, i) => (
                            <span key={i} className={i < rating ? 'star-filled' : 'star-empty'}>
                              <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/></svg>
                            </span>
                          ))}
                        </div>
                        <blockquote className="testimonial-text">{testimonial.comment}</blockquote>
                        <div className="testimonial-author">
                          <span className="testimonial-avatar">{testimonial.name.charAt(0)}</span>
                          <div>
                            <strong className="testimonial-name">{testimonial.name}</strong>
                            {testimonial.company && <span className="testimonial-company">{testimonial.company}</span>}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="testimonials-nav">
              <div className="testimonials-dots">
                {testimonials.map((_, index) => (
                  <button
                    key={index}
                    type="button"
                    className={`testimonial-dot ${index === currentIndex ? 'active' : ''}`}
                    onClick={() => setCurrentIndex(index)}
                    aria-label={`Yorum ${index + 1}`}
                  />
                ))}
              </div>
              <p className="testimonials-counter">
                {currentIndex + 1} / {testimonials.length}
              </p>
            </div>
          </>
        )}
      </div>
    </section>
  );
};

export default Testimonials;
